export const units = {
  KG: 'kg',
  METR: 'metr',
  LITR: 'litr',
}
